<footer class="footer">
  <div
    class="footer__top"
    [ngStyle]="{
      'border-bottom': isLandingPage ? 'none' : '1px solid #E4E4E7'
    }"
  >
    <div class="column left">
      <app-logo></app-logo>
      <p
        [ngStyle]="{
          color: isLandingPage ? 'var(--background-color)' : 'var(--dark-grey)'
        }"
      >
        © {{ currentYear }} MyVet S.r.l<br />
        P.IVA 04692610407<br />
        MyVet® è un marchio registrato di MyVet S.r.l.
      </p>
    </div>

    <div class="container">
      <div class="column center">
        <h6>Help</h6>

        <ul class="list">
          <li>
            <a href="https://myvet.it/legal-docs/privacy-policy">Privacy Policy</a>
          </li>

          <li>
            <a href="https://myvet.it/legal-docs/general-conditions">Cookies Policy</a>
          </li>
        </ul>
      </div>

      <div class="column right">
        <h6 >Company</h6>

        <ul class="list">
          <li>
            <a href="mailto:info@myvet.it">
              info&#64;myvet.it
            </a>
          </li>

          <li>
            <a routerLink="">Contattaci</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div
    class="footer__bottom"
    [ngStyle]="{
      'border-bottom': isLandingPage ? 'none' : '1px solid #E4E4E7'
    }"
  >
    <p >Copyright © 2025 MyVet</p>
    <app-socials></app-socials>

    <app-scarica-app></app-scarica-app>

  </div>
</footer>

